<template>
  <article class="info-section elr-container-full">
    <div class="elr-row">
      <div class="elr-col-full">
        <section v-if="grouping">
          <div class="grouping-details">
            <div class="info-section-header">
              <div class="group-heading">
                <InfoSectionHeading>{{grouping.name}}</InfoSectionHeading>
                <p class="info-section-description" v-if="grouping.description">{{grouping.description}}</p>
                <p><router-link :to="`/grouping/${grouping.slug}/related`">See Related Groups</router-link></p>
              </div>
              <GroupingDetails :grouping="grouping" />
              <ItemButtons
                @onRemoveItem="removeItem"
                model="grouping"
                :item="grouping"
                :user="user"
              />
              <div class="button-holder" style="text-align: left; margin-left: 5px;">
                <router-link
                  class="elr-button elr-button-primary"
                  :to="`/grouping/${grouping.slug}/pony/create`"
                >Add Pony to Group</router-link>
              </div>
              <!-- <GroupingActions
                @collectedAll="collectAll"
                @wishlistedAll="wishlistAll"
                @favoritedAll="favoriteAll"
                v-if="authenticated && grouping.id"
                :user="user"
                :ponies="ponies"
                :id="grouping.id"
              /> -->
              <!-- <p class="elr-text-center" v-else style="margin: 20px auto -35px"><router-link to="/login">Login</router-link> to add ponies to your collection</p> -->
            </div>
          </div>
        </section>
        <div class="grouping-ponies">
          <list-item-grid :status="status">
            <PonyCard
              v-for="item in ponies"
              :key="item.slug"
              :user="user"
              :item="item"
              :authenticated="authenticated"
            />
          </list-item-grid>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { infiniteScroll, slugify, showPrompt } from '../../utils/helpers';
import ListItemGrid from '../../components/ListItemGrid/ListItemGrid';
import PonyCard from '../../components/PonyCard/PonyCard';
// import GroupingActions from '../../components/GroupingActions/GroupingActions';
import GroupingDetails from '../../components/GroupingDetails/GroupingDetails';
import ItemButtons from '../../components/ItemButtons/ItemButtons';
import InfoSectionHeading from '../../components/InfoSectionHeading/InfoSectionHeading';

export default {
  name: 'Grouping',
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      num: 50,
    };
  },
  components: {
    PonyCard,
    // GroupingActions,
    GroupingDetails,
    ListItemGrid,
    ItemButtons,
    InfoSectionHeading
  },
  mounted() {
    // if (!this.grouping) {
      this.FETCH({ slug: this.slug, num: this.num });
    // }

    infiniteScroll(() => {
      if (this.nextUrl) {
        this.FETCH_MORE_PONIES({ slug: this.slug, nextUrl: this.nextUrl });
      }
    });
  },
  computed: {
    ...mapGetters('grouping', ['getBySlug']),
    ...mapGetters('pony', ['getPoniesByGrouping']),
    ...mapState({
      user: state => state.currentUser.currentUser,
      role: state => state.currentUser.role,
      status: state => state.grouping.status,
      authenticated: state => state.currentUser.authenticated
    }),
    nextUrl() {
      if (this.grouping) {
        if (this.grouping.ponies) {
          return this.grouping.ponies.nextUrl;
        }

        return null;
      }

      return null;
    },
    grouping() {
      return this.getBySlug(this.slug)
    },
    ponies() {
      // return [];
      return this.getPoniesByGrouping(this.slug)
    }
  },
  methods: {
    ...mapActions('grouping', ['FETCH', 'REMOVE']),
    collectAll() {
      this.ponies.map(o => {
        if (!o.inHerd) {
          o.collected = o.collected + 1;
          o.inHerd = true;
        }
      });
    },
    wishlistAll() {
      this.ponies.map(o => {
        if (!o.inWishlist && !o.inHerd) {
          o.wishlisted = o.wishlisted + 1;
          o.inWishlist = true;
        }
      });
    },
    favoriteAll() {
      this.ponies.map(o => {
        if (!o.inFavorites) {
          o.favorited = o.favorited + 1;
          o.inFavorites = true;
        }
      });
    },
    removeItem({ slug }) {
      showPrompt();

      this.REMOVE({ slug });
    },
    slugify,
  },
  watch: {
    $route() {
      // this.grouping = {};
      // this.ponies = {};
      // this.groupings = [];
      this.FETCH({ slug: this.slug, num: this.num });
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../assets/sass/_config.scss';

.grouping-details-section {
  border-top: 1px solid $accent-color;
  border-bottom: 1px solid $accent-color;
  padding: 20px 0;
  margin-top: 20px;
}
</style>
